"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Circle = function Circle() {
  return _react2.default.createElement(
    "g",
    { id: "circle" },
    _react2.default.createElement("path", {
      d: "M250,0 C111.9,0 0,111.9 0,250 C0,388.1 111.9,500 250,500 C388.1,500 500,388.1 500,250 C500,111.9 388.1,0 250,0 L250,0 L250,0 Z M250,450 C139.5,450 50,360.5 50,250 C50,139.5 139.5,50 250,50 C360.5,50 450,139.5 450,250 L450,250 C450,360.5 360.5,450 250,450 L250,450 Z",
      id: "Shape"
    })
  );
};

exports.default = Circle;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Circle.js
// module id = 2933
// module chunks = 4